const dataLastLevel = [
    { label: "Iya", value: "true" },
    { label: "Tidak", value: "false" },
]

const dataStatus = [
    { label: "Aktif", value: "true" },
    { label: "Tidak Aktif", value: "false" },
]

const typeOptions = [
    { label: "FAQ Chatbot", value: "C" },
    { label: "FAQ Internal", value: "I" },
    { label: "Both", value: "B" },
]

const levelOptions = [
    { label: "1", value: 1 },
    { label: "2", value: 2 },
    { label: "3", value: 3 },
    { label: "4", value: 4 },
    { label: "5", value: 5 },
    { label: "6", value: 6 },
    { label: "7", value: 7 },
    { label: "8", value: 8 },
    { label: "9", value: 9 },
]

const validationCategory = new RegExp(
    '^[a-zA-Z0-9 ]*$'
)

const validationTitle = new RegExp(
    '^[a-zA-Z0-9 ?]*$'
)

const validationUrlLink = new RegExp(
    '(http|https)?://([^ ]+$)'
)

const MENU_KMS = {
    dataLastLevel,
    dataStatus,
    typeOptions,
    levelOptions,
    validationCategory,
    validationTitle,
    validationUrlLink,
}

export default MENU_KMS;